import type { HelpFile } from '../../types/help'
import { InboundConnectorsTestIds } from '../../../testids/InboundConnectorsTestIds'

export const inboundConnectorsHelp: HelpFile = {
  docPage: '/docs/connectors/inbound',
  texts: {
    [InboundConnectorsTestIds.inboundConnectorsList]: 'Inbound connectors pull data from external systems (HR, directories, IGA tools) into IAM, creating or updating parties and identities.',
    [InboundConnectorsTestIds.createInboundConnectorButton]: 'Configure a new inbound connector for a source system.',
    [InboundConnectorsTestIds.inboundConnectorsTable]: 'Each row is one connector — the status badge shows whether it is currently syncing, idle, or in error.',
    [InboundConnectorsTestIds.colLastSync]: 'When the connector last completed a sync — open the connector to see the per-run history.',
    [InboundConnectorsTestIds.inboundConnectorsSkeleton]: null,
  },
}
